import AlertManager from "../../helpers/AlertManager";

export default class Popups {
  constructor(apiUrl, el, storageKey) {
    // super(apiUrl, el, storageKey);
    this.el = el;
    this.storageKey = storageKey;
    this.alert = null;
    this.initialize();
  }

  async initialize() {
    await this.processAlerts();

    if (this.alert) {
      this.displayAlert();
    }
  }

  displayAlert() {
    const delay = this.alert.getAttribute("data-popup-delay");
    const id = this.alert.getAttribute("data-id");
    const popup = $(this.alert).closest('.popup');
    const self = this;
    
    setTimeout(() => {
      popup
        .fadeIn()
        .css({ 'display': 'flex', 'flex-direction': 'row' });;
    }, delay);

    this.alert.querySelector('.close').addEventListener("click", () => {
      popup.fadeOut();
      self.handleAlertClose(id);
    });
  }

  async processAlerts() {
    const alerts = $(".view-id-popups .popup");

    if (alerts.length === 0) {
      console.warn("No alerts found.");
      return;
    }

    const currentPath = window.location.pathname;
    let priorityAlert;

    for (let i = 0; i < alerts.length; i++) {
      const alert = alerts[i];
      const alertId = alert.getAttribute("data-id");

      if (!this.isAlertDismissed(alertId)) {
        priorityAlert = alerts[i];
        break;
      }
    }

    if (priorityAlert && !this.isAlertDismissed(priorityAlert.id)) {
      this.alert = priorityAlert;
    }
  }

  isAlertDismissed(alertId) {
    const dismissedAlerts = JSON.parse(localStorage.getItem(this.storageKey)) || [];
    return dismissedAlerts.includes(alertId);
  }

  // Event listener for closing alert
  handleAlertClose(alertId) {
    console.log(alertId);
    const dismissedAlerts = JSON.parse(localStorage.getItem(this.storageKey)) || [];
    dismissedAlerts.push(alertId);
    localStorage.setItem(this.storageKey, JSON.stringify(dismissedAlerts));
  }
}